import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTrillerComponent } from './simple-icons-triller.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTrillerComponent ],
    exports:      [ SimpleIconsTrillerComponent ],
    bootstrap:    []
})
export class SimpleIconsTrillerModule {}
